import { CellValue } from "@inscopix/ideas-hyperformula/typings/CellValue";
import { memo, useCallback } from "react";
import { ToolSpec } from "types/json-schemas/type_guards";
import { ResourceTier } from "types/ResourceTiers";
import { CellEditorComputeResourcesBase } from "./CellEditorComputeResourcesBase";
import { useDataTableContext } from "../store/DataTableProvider";

interface CellEditorComputeResourcesProps {
  rowId: string;
  toolVersionResources: ToolSpec["resources"];
  toolVersionCredits: number;
  value: CellValue;

  stopEditing: (cancel?: boolean) => void;
  tableId: string;
}

/**
 * Cell editor for resource tier on GDT analysis table rows
 * where resource tier is stored as a value on the row itself
 */

export const CellEditorComputeResourcesGdtAnalysisTableRow = memo(
  function CellEditorComputeResourcesGdtAnalysisTable({
    rowId,
    stopEditing,
    tableId,
    toolVersionCredits,
    toolVersionResources,
    value,
  }: CellEditorComputeResourcesProps) {
    const updateAnalysisTableRow = useDataTableContext(
      (s) => s.updateAnalysisTableRow,
    );

    const handleSelectResourceTier = useCallback(
      (resourceTier: ResourceTier["id"] | null) => {
        void updateAnalysisTableRow({
          tableId,
          rowId,
          resourceTierId: resourceTier,
        });
      },
      [rowId, tableId, updateAnalysisTableRow],
    );

    return (
      <CellEditorComputeResourcesBase
        toolVersionResources={toolVersionResources}
        toolVersionCredits={toolVersionCredits}
        value={value}
        onSelectResourceTier={handleSelectResourceTier}
        stopEditing={stopEditing}
      />
    );
  },
);
